import { useState } from 'react';

const DirectionsSection = () => {
  const [activeTab, setActiveTab] = useState<'world' | 'russia'>('world');

  const worldDirections = [
    {
      id: 1,
      image: 'https://public.readdy.ai/ai/img_res/00646cf46c9ca249520a285cf8005dec.jpg',
      title: 'Исландия',
      description: 'Земля льда и огня с невероятными пейзажами'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Breathtaking%20Nepal%20Himalayas%20mountain%20peaks%20snow%20capped%20mountains%20dramatic%20mountain%20landscape%20professional%20travel%20photography%20vibrant%20natural%20colors%20clear%20blue%20sky%20sense%20of%20adventure&width=400&height=267&seq=world-2&orientation=landscape',
      title: 'Непал',
      description: 'Величественные Гималаи и древние традиции'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Tanzania%20Kilimanjaro%20mountain%20landscape%20with%20acacia%20trees%20African%20savanna%20dramatic%20sunset%20professional%20travel%20photography%20vibrant%20warm%20colors%20sense%20of%20adventure%20exploration&width=400&height=267&seq=world-3&orientation=landscape',
      title: 'Танзания',
      description: 'Килиманджаро и удивительные национальные парки'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Magnificent%20Norway%20fjords%20dramatic%20mountain%20cliffs%20deep%20blue%20water%20scenic%20Nordic%20landscape%20professional%20travel%20photography%20vibrant%20natural%20colors%20sense%20of%20wonder&width=400&height=267&seq=world-4&orientation=landscape',
      title: 'Норвегия',
      description: 'Фьорды и северное сияние'
    }
  ];

  const russiaDirections = [
    {
      id: 1,
      image: 'https://readdy.ai/api/search-image?query=Majestic%20Kamchatka%20Peninsula%20volcanoes%20geysers%20pristine%20wilderness%20dramatic%20Russian%20landscape%20professional%20travel%20photography%20vibrant%20natural%20colors%20sense%20of%20adventure&width=400&height=267&seq=russia-1&orientation=landscape',
      title: 'Камчатка',
      description: 'Вулканы, гейзеры и дикая природа'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Baikal%20lake%20crystal%20clear%20water%20surrounded%20by%20mountains%20pristine%20Siberian%20nature%20professional%20travel%20photography%20vibrant%20blue%20colors%20peaceful%20atmosphere&width=400&height=267&seq=russia-2&orientation=landscape',
      title: 'Байкал',
      description: 'Самое глубокое озеро планеты'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Spectacular%20Altai%20mountains%20golden%20meadows%20pristine%20wilderness%20dramatic%20Russian%20landscape%20professional%20travel%20photography%20vibrant%20natural%20colors%20clear%20mountain%20air&width=400&height=267&seq=russia-3&orientation=landscape',
      title: 'Алтай',
      description: 'Золотые горы и чистейший воздух'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Stunning%20Caucasus%20mountains%20Elbrus%20snow%20capped%20peaks%20dramatic%20mountain%20landscape%20professional%20travel%20photography%20vibrant%20natural%20colors%20sense%20of%20adventure&width=400&height=267&seq=russia-4&orientation=landscape',
      title: 'Кавказ',
      description: 'Эльбрус и горные традиции'
    }
  ];

  const handleTabClick = (tab: 'world' | 'russia') => {
    setActiveTab(tab);
  };

  const handleKeyDown = (event: React.KeyboardEvent, tab: 'world' | 'russia') => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setActiveTab(tab);
    }
  };

  const currentDirections = activeTab === 'world' ? worldDirections : russiaDirections;

  return (
    <section className="bg-gray-50 py-16 md:py-20 lg:py-24" aria-labelledby="directions-heading">
      <div className="max-w-[1360px] mx-auto px-6">
        <div className="text-center mb-12">
          <h2 id="directions-heading" className="font-mulish font-bold text-3xl lg:text-4xl text-gray-900 mb-4">
            Направления
          </h2>
          <p className="font-open-sans text-lg text-gray-600 max-w-2xl mx-auto">
            Откройте мир и Россию вместе с нами
          </p>
        </div>

        {/* Табы */}
        <div className="flex justify-center mb-12">
          <div 
            className="flex bg-white rounded-full p-1 shadow-sm border border-gray-200"
            role="tablist"
            aria-label="Выбор направлений"
          >
            <button
              role="tab"
              aria-selected={activeTab === 'world'}
              aria-controls="world-panel"
              id="world-tab"
              className={`px-8 py-3 rounded-full font-mulish font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === 'world'
                  ? 'bg-[#1E88E5] text-white shadow-sm'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
              onClick={() => handleTabClick('world')}
              onKeyDown={(e) => handleKeyDown(e, 'world')}
            >
              По Миру
            </button>
            <button
              role="tab"
              aria-selected={activeTab === 'russia'}
              aria-controls="russia-panel"
              id="russia-tab"
              className={`px-8 py-3 rounded-full font-mulish font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === 'russia'
                  ? 'bg-[#1E88E5] text-white shadow-sm'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
              onClick={() => handleTabClick('russia')}
              onKeyDown={(e) => handleKeyDown(e, 'russia')}
            >
              По России
            </button>
          </div>
        </div>

        {/* Контент табов */}
        <div
          role="tabpanel"
          id={activeTab === 'world' ? 'world-panel' : 'russia-panel'}
          aria-labelledby={activeTab === 'world' ? 'world-tab' : 'russia-tab'}
        >
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {currentDirections.map((direction) => (
              <li key={direction.id}>
                <a
                  href="/regions"
                  className="block bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 group cursor-pointer h-full"
                >
                  <div className="aspect-[3/2] overflow-hidden">
                    <img
                      src={direction.image}
                      alt={direction.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="font-mulish font-bold text-lg text-gray-900 mb-2 group-hover:text-[#1E88E5] transition-colors duration-300">
                      {direction.title}
                    </h3>
                    <p className="font-open-sans text-sm text-gray-600 leading-relaxed">
                      {direction.description}
                    </p>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Кнопка "Все регионы" */}
        <div className="text-center">
          <a
            href="/regions"
            className="inline-block bg-[#1E88E5] hover:bg-[#0D47A1] text-white font-open-sans font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Все регионы
          </a>
        </div>
      </div>
    </section>
  );
};

export default DirectionsSection;
